module.exports = __webpack_public_path__ + "img/selected3-min.3db579d0.png";